"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var Bullets = function Bullets(_ref) {
  var bullets = _ref.bullets,
      className = _ref.className,
      style = _ref.style;
  return _react.default.createElement("div", {
    className: className,
    style: style
  }, bullets.map(function (bullet, b) {
    var isTextBullet = (0, _lodash.isString)(bullet);
    return _react.default.createElement("div", {
      className: "flex-row margin-bottom-1",
      key: b
    }, _react.default.createElement("div", {
      className: "padding-right-4 break-word",
      style: {
        width: '35%'
      }
    }, isTextBullet || !bullet.title ? '•' : bullet.title), _react.default.createElement("div", {
      className: "flex-1"
    }, isTextBullet ? bullet : bullet.content));
  }));
};

Bullets.defaultProps = {
  bullets: []
};
var _default = Bullets;
exports.default = _default;